import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddUpdateGruppoStudioCommand } from 'src/app/model/command-model';
import {
  AbilitaDisabilitaCommand,
  AppelloCommand,
  EliminaCommand,
  GetCommand,
  GetGruppoStudioCommand,
  SearchGruppoStudioCommand,
  SelectCommand,
} from '../../../model/command-model';
import { MioGruppoStudioDTO } from '../../../model/newModel';
import { ConstantsCLA } from '../../../shared/constants-cla';
import {
  GruppoStudioDTO,
  ListGruppiStudioDTO,
  ListMieiGruppiStudioDTO,
  ListSelectDTO,
  SessioneOlaStudenteDTO,
} from './../../../model/newModel';

@Injectable({
  providedIn: 'root',
})
export class AGruppoStudioService {
  constructor(private http: HttpClient) {}

  getCounts() {
    // CICLO PER AULA GIORNO ORA LEZIONE
    const counts = [
      {
        idAula: 'idAula1',
        idGiorno: 'idGiorno1',
        idOraInizio: 'idOraInizio1',
        idOraFine: 'idOraFine1',
      },
      {
        idAula: 'idAula2',
        idGiorno: 'idGiorno2',
        idOraInizio: 'idOraInizio2',
        idOraFine: 'idOraFine2',
      },
      {
        idAula: 'idAula3',
        idGiorno: 'idGiorno3',
        idOraInizio: 'idOraInizio3',
        idOraFine: 'idOraFine3',
      },
      {
        idAula: 'idAula4',
        idGiorno: 'idGiorno4',
        idOraInizio: 'idOraInizio4',
        idOraFine: 'idOraFine4',
      },
      {
        idAula: 'idAula5',
        idGiorno: 'idGiorno5',
        idOraInizio: 'idOraInizio5',
        idOraFine: 'idOraFine5',
      },
      {
        idAula: 'idAula6',
        idGiorno: 'idGiorno6',
        idOraInizio: 'idOraInizio6',
        idOraFine: 'idOraFine6',
      },
      {
        idAula: 'idAula7',
        idGiorno: 'idGiorno7',
        idOraInizio: 'idOraInizio7',
        idOraFine: 'idOraFine7',
      },
    ];
    return counts;
  }

  abilitaDisabilita(id: number, isAbilita: boolean) {
    const command = new AbilitaDisabilitaCommand();
    command.id = id;
    command.active = isAbilita;
    return this.http.post<boolean>(
      ConstantsCLA.ABILITA_DISABILITA_GRUPPO_STUDIO_URL,
      command
    );
  }

  duplicaGruppo(idGruppo: number) {
    const command = new GetCommand();
    command.id = idGruppo;
    return this.http.post<Boolean>(ConstantsCLA.DUPLICA_GRUPPO_URL, command);
  }

  selectAule() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(ConstantsCLA.AULE_COMBO_URL, command);
  }

  selectLanguageLevels() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.LANGUAGE_LEVELS_COMBO_URL,
      command
    );
  }

  selectFasceOrarie() {
    const command = new SelectCommand();
    return this.http.post<ListSelectDTO>(
      ConstantsCLA.FASCE_ORARIE_COMBO_URL,
      command
    );
  }

  save(newGruppoStudio: AddUpdateGruppoStudioCommand) {
    return this.http.post<AddUpdateGruppoStudioCommand>(
      ConstantsCLA.CREA_GRUPPO_STUDIO_URL,
      newGruppoStudio
    );
  }

  update(updateGruppoStudio: AddUpdateGruppoStudioCommand) {
    return this.http.post<AddUpdateGruppoStudioCommand>(
      ConstantsCLA.MODIFICA_GRUPPO_STUDIO_URL,
      updateGruppoStudio
    );
  }

  getGruppoStudio(id: number) {
    const command = new GetGruppoStudioCommand();
    command.id = id;
    command.withInfoCorsoLaurea = true;
    command.withInfoLanguageLevels = true;
    command.withInfoStudente = true;
    return this.http.post<GruppoStudioDTO>(
      ConstantsCLA.GET_GRUPPO_STUDIO_URL,
      command
    );
  }

  getPercentualeGruppoStudio(id: number) {
    const command = new GetGruppoStudioCommand();
    command.id = id;
    return this.http.post<MioGruppoStudioDTO>(
      ConstantsCLA.GET_PERCENTUALE_GRUPPO_STUDIO_URL,
      command
    );
  }

  eliminaGruppoStudio(id: number) {
    const command = new EliminaCommand();
    command.id = id;
    return this.http.post<Boolean>(
      ConstantsCLA.ELIMINA_GRUPPO_STUDIO_URL,
      command
    );
  }

  search(
    idSessioneOla: number,
    nomeGruppo: string,
    idInstructor: string,
    idCorsoLaurea: string,
    idGiorno: string
  ) {
    const command = new SearchGruppoStudioCommand();
    command.skip = 0;
    command.take = 25;
    command.idSessioneOla = idSessioneOla;
    command.nomeGruppo = nomeGruppo;
    command.idInstructor = !!idInstructor ? idInstructor : null;
    command.idCorsoLaurea = !!idCorsoLaurea ? Number(idCorsoLaurea) : null;
    command.idGiorno = !!idGiorno ? idGiorno : null;

    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  previousPage(
    idSessioneOla: number,
    nomeGruppo: string,
    idInstructor: string,
    idCorsoLaurea: string,
    idGiorno: string,
    skip: number,
    take: number
  ) {
    const skipNew = skip - 1 < 0 ? 0 : skip - 1;
    const command = new SearchGruppoStudioCommand();
    command.skip = skipNew;
    command.take = take;
    command.idSessioneOla = idSessioneOla;
    command.nomeGruppo = nomeGruppo;
    command.idInstructor = !!idInstructor ? idInstructor : null;
    command.idCorsoLaurea = !!idCorsoLaurea ? Number(idCorsoLaurea) : null;
    command.idGiorno = !!idGiorno ? idGiorno : null;

    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  nextPage(
    idSessioneOla: number,
    nomeGruppo: string,
    idInstructor: string,
    idCorsoLaurea: string,
    idGiorno: string,
    skip: number,
    take: number,
    count: number
  ) {
    const skipNew = skip + 1;
    const command = new SearchGruppoStudioCommand();
    command.skip = skipNew;
    command.take = take;
    command.idSessioneOla = idSessioneOla;
    command.nomeGruppo = nomeGruppo;
    command.idInstructor = !!idInstructor ? idInstructor : null;
    command.idCorsoLaurea = !!idCorsoLaurea ? Number(idCorsoLaurea) : null;
    command.idGiorno = !!idGiorno ? idGiorno : null;
    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  goToPage(
    idSessioneOla: number,
    nomeGruppo: string,
    idInstructor: string,
    idCorsoLaurea: string,
    idGiorno: string,
    idVaiA: string,
    take: number
  ) {
    const command = new SearchGruppoStudioCommand();
    command.skip = Number(idVaiA);
    command.take = take;
    command.idSessioneOla = idSessioneOla;
    command.nomeGruppo = nomeGruppo;
    command.idInstructor = !!idInstructor ? idInstructor : null;
    command.idCorsoLaurea = !!idCorsoLaurea ? Number(idCorsoLaurea) : null;
    command.idGiorno = !!idGiorno ? idGiorno : null;
    return this.http.post<ListGruppiStudioDTO>(
      ConstantsCLA.SEARCH_GRUPPO_STUDIO_URL,
      command
    );
  }

  getMieiCalendariGruppiStudio(idInstructor: number) {
    const command = new GetCommand();
    command.id = idInstructor;
    return this.http.post<ListMieiGruppiStudioDTO>(
      ConstantsCLA.I_MIEI_CALENDARI_GRUPPI_STUDIO_URL,
      command
    );
  }

  appelloGruppoStudio(
    idGruppoStudio: number,
    listaPresenti: SessioneOlaStudenteDTO[],
    oraAppello: string,
    dataAppello: Date,
    numeroOreAppello: number,
    idInstructor: number
  ) {
    const command = new AppelloCommand();
    command.listaPresenti = listaPresenti;
    command.idGruppoStudio = idGruppoStudio;
    command.oraAppello = oraAppello;
    command.dataAppello = dataAppello;
    command.idInstructor = idInstructor;
    command.numeroOreAppello = numeroOreAppello;

    return this.http.post<Boolean>(
      ConstantsCLA.APPELLO_GRUPPO_STUDIO_URL,
      command
    );
  }

  appelloGruppoStudioInstructor(
    idGruppoStudio: number,
    oraAppello: string,
    dataAppello: Date,
    numeroOreAppello: number,
    idInstructor: number
  ) {
    const command = new AppelloCommand();
    command.idGruppoStudio = idGruppoStudio;
    command.oraAppello = oraAppello;
    command.dataAppello = dataAppello;
    command.idInstructor = idInstructor;
    command.numeroOreAppello = numeroOreAppello;

    return this.http.post<Boolean>(
      ConstantsCLA.APPELLO_GRUPPO_STUDIO_INSTRUCTOR_URL,
      command
    );
  }
}
